import { createSelector } from "reselect";

import { TableSelectionState } from "./types";

const selectSelectedCount = createSelector(
  (state: TableSelectionState) => state.selected,
  (selected): number => selected.size
);

const selectDisabledCount = createSelector(
  (state: TableSelectionState) => state.disabledIds,
  (disabledIds): number => disabledIds.size
);

export const selectSelectionIsStarted = createSelector(
  selectSelectedCount,
  (selectedCount): boolean => selectedCount > 0
);

export const selectIsFullySelected = createSelector(
  selectSelectedCount,
  selectDisabledCount,
  (state: TableSelectionState) => state.allItemsCount,
  selectSelectionIsStarted,
  (selectedCount, disabledCount, allItemsCount, selectionIsStarted): boolean =>
    selectionIsStarted && selectedCount + disabledCount === allItemsCount
);

export const selectIsIndeterminate = createSelector(
  selectSelectedCount,
  selectDisabledCount,
  (state: TableSelectionState) => state.allItemsCount,
  selectSelectionIsStarted,
  (selectedCount, disabledCount, allItemsCount, selectionIsStarted): boolean =>
    selectionIsStarted && selectedCount + disabledCount < allItemsCount
);
